import { CheckboxStandaloneUnstyled } from 'Components/Form/CheckboxStandalone/unstyled'
import styled from 'styled-components'

export const CheckboxStandalone = styled(CheckboxStandaloneUnstyled)`
  position: relative;
  height: 23px;

  .checkbox-wrapper {
    position: relative;
    width: 23px;
    height: 23px;
    float: left;

    input {
      -webkit-appearance: none;
      position: absolute;
      background: ${props => props.theme.colors.iron};
      width: 100%;
      height: 100%;
      border: none;
      opacity: 1;
      margin: 0;
      border-radius: 2px;
      top: 50%;
      transform: translateY(-50%);
      cursor: ${props => (props.disabled ? 'auto' : 'pointer')};

      &:focus {
        outline: 0;
      }

      &:checked {
        background: ${props => props.theme.colors.primary};

        & + svg {
          display: initial;
        }
      }

      &:disabled {
        cursor: auto;
      }

      & + svg {
        display: none;
      }
    }

    svg {
      position: absolute;
      height: 100%;
      width: 14px;
      top: 0;
      left: 0;
      right: 0;
      fill: ${props => props.theme.colors.white};
      margin: auto;
      pointer-events: none;
    }
  }

  label {
    display: block;
    float: left;
    display: ${props => (props.label ? 'initial' : 'none')};
    line-height: 23px;
    font-family: ${props => props.theme.fonts.robotoRegular};
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    padding: 0 0 0 10px;
    cursor: ${props => (props.disabled ? 'auto' : 'pointer')};
  }
`
